export const API_KEY = "c5dcacca1568e3f2c0162ecfbaa5f19c";

export const BASE_URL = "https://api.themoviedb.org/3";
export const IMAGE_URL = "https://image.tmdb.org/t/p/w500";

export const DEFAULT_LANGUAGE = "en-US";
export const DEFAULT_REGION = "US";

export const MOOD_GENRE_MAP = {
  happy: 35,
  sad: 18,
  excited: 28,
  scared: 27,
  romantic: 10749
};


